import durationChangeHandler from './durationChangeHandler';
import bitrateChangeHandler from './bitrateChangeHandler';
import seekingHandler from './seekingHandler';
import { EventReport, PlayerEventReporter } from './interfaces';

const isPlayerEventHandled = (
  event: EventReport,
  reporter: PlayerEventReporter
): boolean => {
  const synthetic = event.synthetic || false;
  // Change Handlers return true if the event is fully handled
  return (
    bitrateChangeHandler(event, reporter) ||
    durationChangeHandler(event, reporter) ||
    seekingHandler(event, reporter) ||
    synthetic
  );
};

export default isPlayerEventHandled;
